var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.453 11.368C23.244 11.128 18.291 5.5 12 5.5c-6.292 0-11.245 5.628-11.452 5.868L0 12l0.548 0.632 C0.755 12.871 5.708 18.5 12 18.5c6.291 0 11.244-5.629 11.453-5.868L24 12L23.453 11.368z M12 16.559 c-4.23 0-7.939-3.175-9.356-4.559C4.061 10.615 7.77 7.44 12 7.44c4.23 0 7.939 3.175 9.355 4.56 C19.939 13.384 16.23 16.559 12 16.559z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92 12c0 1.681 1.382 3.05 3.08 3.05c1.697 0 3.08-1.369 3.08-3.05c0-1.682-1.383-3.05-3.08-3.05 C10.302 8.95 8.92 10.318 8.92 12z M13.123 12c0 0.612-0.504 1.109-1.123 1.109S10.879 12.612 10.879 12s0.502-1.11 1.121-1.11 S13.123 11.388 13.123 12z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default ForwardRef;